import React, { FC } from 'react'

import logoDicBlue from '../../assets/img/logo-dipendenticloud-blue.png'
import logoNewBlue from '../../assets/img/logo-new-blue.png'
import logoNewBlue2 from '../../assets/img/logo-new-blue@2x.png'
import logoNewBlue3 from '../../assets/img/logo-new-blue@3x.png'
import { locale } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import ExitEditorMode from '../ExitEditorMode/ExitEditorMode'
import { TopHeaderProps } from './definitions'
import FBCommunityBanner from './FBCommunityBanner'
import { TopHeaderContainer } from './header.components'
import TopButtons from './TopButtons'

const TopHeader: FC<TopHeaderProps> = (props: TopHeaderProps) => {
  const realm = useAppSelector((state) => state.realm.value)
  const adminMode = useAppSelector((state) => state.adminMode.value)

  return (
    <TopHeaderContainer>
      {realm === 'fic' && <FBCommunityBanner />}
      <div className='headerContainer'>
        {realm === 'fic' && (
          <img
            src={logoNewBlue}
            srcSet={logoNewBlue2 + ' 2x, ' + logoNewBlue3 + ' 3x'}
            className={'logo'}
            alt={'logo'}
            onClick={() => props.changeView(undefined, 'main')}
          />
        )}

        {realm === 'dic' && (
          <img
            src={logoDicBlue}
            className={'logo'}
            alt={'logo'}
            onClick={() => props.changeView(undefined, 'main')}
            style={{ height: 32 }}
          />
        )}
        {realm === 'dic-es' && (
          <img
            src={logoDicBlue}
            className={'logo'}
            alt={'logo'}
            onClick={() => props.changeView(undefined, 'main')}
            style={{ height: 32 }}
          />
        )}

        {realm === 'resellers' && (
          <>
            <img
              style={{ marginRight: '8px' }}
              src={logoNewBlue}
              srcSet={logoNewBlue2 + ' 2x, ' + logoNewBlue3 + ' 3x'}
              className={'logo'}
              alt={'logo'}
              onClick={() => props.changeView(undefined, 'main')}
            />
            <img
              src={logoDicBlue}
              className={'logo'}
              alt={'logo'}
              onClick={() => props.changeView(undefined, 'main')}
              style={{ height: 32 }}
            />
          </>
        )}
        <h1 className={'defaultTitle'}>{locale('Supporto clienti')}</h1>
        {!adminMode && <TopButtons />}
        {adminMode && <ExitEditorMode buttonClass={''} />}
      </div>
    </TopHeaderContainer>
  )
}

export default TopHeader
